/* eslint-disable @typescript-eslint/no-explicit-any */
export const handleSelectMenuOpen = (): void => {
  setTimeout(() => {
    const menuList: any = document.querySelector(".custom-select__menu-list");
    if (menuList) {
      menuList.style.overflowY = "auto";
      menuList.style.touchAction = "pan-y";
      menuList.style.WebkitOverflowScrolling = "touch";
      
      // Remover el listener anterior si existe
      const existingListener = menuList._touchMoveHandler;
      if (existingListener) {
        menuList.removeEventListener("touchmove", existingListener);
      }
      
      const touchMoveHandler = (e: any) => e.stopPropagation();
      
      // Guardar la referencia de la función en el elemento
      menuList._touchMoveHandler = touchMoveHandler;
      
      menuList.addEventListener("touchmove", touchMoveHandler, {
        passive: true,
      });
    }

    const selectedOption: Element | undefined = document.getElementsByClassName(
      "custom-select__option--is-selected",
    )[0];

    if (selectedOption) {
      selectedOption.scrollIntoView({
        block: "center",
        inline: "end",
      });
    }
  }, 0);
};

export const defaultSelectCustomStyles = {
  input: (styles: object) => ({
    ...styles,
    height: "30px",
    flex: "0.5",
    outline: "none",
    fontSize: "0.875rem",
    fontWeight: "400",
    lineHeight: "1.25rem",
    cursor: "pointer",
  }),
  placeholder: (styles: object) => ({
    ...styles,
    color: "#6B7280",
    fontSize: "0.875rem",
    fontWeight: "400",
  }),
  control: (styles: object, { isDisabled }: any) => ({
    ...styles,
    backgroundColor: isDisabled ? "rgb(209 213 219 / 0.2)" : "#FFFFFF",
    outline: "none",
    borderColor: "#E5E7EB",
  }),
  valueContainer: (styles: object) => ({
    ...styles,
    padding: "2px 10px",
  }),
  singleValue: (styles: object, { isDisabled }: any) => ({
    ...styles,
    color: isDisabled ? "#585F6D" : "#000000",
    fontWeight: "400",
  }),
  multiValue: (styles: object) => ({
    ...styles,
    backgroundColor: "#D7015A",
    borderRadius: "4px",
  }),
  multiValueLabel: (styles: object) => ({
    ...styles,
    color: "#FFFFFF",
    fontWeight: "100",
    paddingTop: "5px",
  }),
  multiValueRemove: (styles: object) => ({
    ...styles,
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px",
    color: "#FFFFFF",
    ":hover": {
      backgroundColor: "#F9FAFA",
      color: "#FFFFFF",
    },
  }),
  menu: (styles: object) => ({
    ...styles,
    zIndex: 9999,
  }),
  menuList: (styles: object) => ({
    ...styles,
    padding: "0px 5px",
  }),
  menuPortal: (styles: object) => ({
    ...styles,
    fontFamily: "Inter",
    fontSize: "0.875rem",
    fontWeight: "400",
    zIndex: 9999,
  }),
  option: (styles: object, { isSelected }: any) => ({
    ...styles,
    backgroundColor: isSelected ? "#F3F4F6" : "#FFFFFF",
    color: isSelected ? "#000000" : "#000000",
    fontWeight: "400",
    padding: "6px 8px",
    borderRadius: "6px",
    margin: "5px 0px",
    ":hover": {
      backgroundColor: "#F3F4F6",
      color: "#000000",
      cursor: "pointer",
    },
  }),
};
